import { Link } from 'react-router-dom';

const encyclopediaLinks = [
  { label: 'Что такое корпоративное обучение', to: '/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie' },
  { label: 'Обучение персонала', to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-personala' },
  { label: 'Обучение отдела продаж', to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh' },
  { label: 'Тренинг для руководителей', to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley' },
  { label: 'Развитие Soft Skills', to: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills' },
  { label: 'Командообразование', to: '/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie' },
  { label: 'Адаптация сотрудников', to: '/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov' },
  { label: 'Корпоративная академия', to: '/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya' },
  { label: 'Оценка эффективности', to: '/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya' },
  { label: 'Разработка программ обучения', to: '/enciklopediya-korporativnogo-obucheniya/razrabotka-programm-obucheniya' },
];

const salesLinks = [
  { label: 'Тренинг по продажам', to: '/prodazhi-i-peregovory/trening-po-prodazham' },
  { label: 'Тренинг по переговорам', to: '/prodazhi-i-peregovory/trening-po-peregovoram' },
  { label: 'Холодные звонки', to: '/prodazhi-i-peregovory/trening-po-holodnym-zvonkam' },
  { label: 'Телефонные продажи', to: '/prodazhi-i-peregovory/trening-po-telefonnym-prodazham' },
  { label: 'Выявление потребностей', to: '/prodazhi-i-peregovory/trening-po-vyyavleniyu-potrebnostey' },
  { label: 'Работа с возражениями', to: '/prodazhi-i-peregovory/trening-po-rabote-s-vozrazheniyami' },
  { label: 'Работа с клиентами', to: '/prodazhi-i-peregovory/trening-po-rabote-s-klientami' },
  { label: 'B2B продажи', to: '/prodazhi-i-peregovory/trening-po-prodazham-b2b' },
  { label: 'Продажи через переписку', to: '/prodazhi-i-peregovory/trening-po-prodazham-cherez-perepisku' },
];

const managementLinks = [
  { label: 'Тренинг по лидерству', to: '/menedzhment-i-liderstvo/trening-po-liderstvu' },
  { label: 'Делегирование и постановка задач', to: '/menedzhment-i-liderstvo/delegirovanie-i-postanovka-zadach' },
  { label: 'Обратная связь и сложные разговоры', to: '/menedzhment-i-liderstvo/obratnaya-svyaz-i-slozhnye-razgovory' },
  { label: 'Мотивация и управление командой', to: '/menedzhment-i-liderstvo/motivatsiya-i-upravlenie-komandoy' },
  { label: 'Управление конфликтами', to: '/menedzhment-i-liderstvo/trening-po-upravleniyu-konfliktami' },
  { label: 'Управленческие переговоры', to: '/menedzhment-i-liderstvo/upravlencheskie-peregovory' },
  { label: 'Руководитель в переговорах', to: '/menedzhment-i-liderstvo/rukovoditel-v-peregovorah' },
  { label: 'Управление изменениями', to: '/menedzhment-i-liderstvo/upravlenie-izmeneniyami' },
  { label: 'Развитие управленческих компетенций', to: '/menedzhment-i-liderstvo/razvitie-upravlencheskih-kompetenciy' },
  { label: 'Наставничество и развитие сотрудников', to: '/menedzhment-i-liderstvo/nastavnichestvo-i-razvitie-sotrudnikov' },
];

const personnelLinks = [
  { label: 'Оценка и развитие сотрудников', to: '/razvitie-personala/otsenka-i-razvitie-sotrudnikov' },
  { label: 'Индивидуальный план развития', to: '/razvitie-personala/individualnyy-plan-razvitiya-sotrudnikov' },
  { label: 'Кадровый резерв', to: '/razvitie-personala/kadrovyy-rezerv' },
];

export default function Footer() {
  return (
    <footer className="bg-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-10">
          {/* Logo + About */}
          <div className="col-span-2 md:col-span-1 min-w-0">
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <img
                src="https://static.readdy.ai/image/045fa1b133efd9567759baab28602a6d/61a59271a80ff4d07ef88e35462987b3.png"
                alt="Business Training"
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-gray-300 leading-relaxed text-sm">
              Профессиональные корпоративные тренинги, обучение сотрудников, тимбилдинги и бизнес-игры в Минске, Беларуси, России, Казахстане, Узбекистане и Израиле
            </p>
          </div>

          {/* Навигация */}
          <div className="min-w-0">
            <h4 className="text-base font-semibold mb-4 text-white">Навигация</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-gray-300 hover:text-white transition-colors text-sm cursor-pointer">Главная</Link>
              <Link to="/enciklopediya-korporativnogo-obucheniya" className="text-gray-300 hover:text-white transition-colors text-sm cursor-pointer">Энциклопедия</Link>
              <Link to="/prodazhi-i-peregovory" className="text-gray-300 hover:text-white transition-colors text-sm cursor-pointer">Продажи и переговоры</Link>
              <Link to="/menedzhment-i-liderstvo" className="text-gray-300 hover:text-white transition-colors text-sm cursor-pointer">Менеджмент и лидерство</Link>
              <Link to="/razvitie-personala" className="text-gray-300 hover:text-white transition-colors text-sm cursor-pointer">Развитие персонала</Link>
              <Link to="/o-trenere" className="text-gray-300 hover:text-white transition-colors text-sm cursor-pointer">О тренере</Link>
              <Link to="/contacts" className="text-gray-300 hover:text-white transition-colors text-sm cursor-pointer">Контакты</Link>
            </div>
          </div>

          {/* Менеджмент и лидерство */}
          <div className="min-w-0">
            <Link to="/menedzhment-i-liderstvo" className="block text-base font-semibold mb-4 text-white hover:text-teal-300 transition-colors cursor-pointer">Менеджмент и лидерство</Link>
            <div className="flex flex-col gap-2">
              {managementLinks.map((item) => (
                <Link key={item.to} to={item.to} className="text-gray-300 hover:text-white transition-colors text-sm cursor-pointer break-words">
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Энциклопедия */}
          <div className="min-w-0">
            <Link to="/enciklopediya-korporativnogo-obucheniya" className="block text-base font-semibold mb-4 text-white hover:text-teal-300 transition-colors cursor-pointer">Энциклопедия</Link>
            <div className="flex flex-col gap-2">
              {encyclopediaLinks.map((item) => (
                <Link key={item.to} to={item.to} className="text-gray-300 hover:text-white transition-colors text-sm cursor-pointer break-words">
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Продажи и переговоры */}
          <div className="min-w-0">
            <Link to="/prodazhi-i-peregovory" className="block text-base font-semibold mb-4 text-white hover:text-teal-300 transition-colors cursor-pointer">Продажи и переговоры</Link>
            <div className="flex flex-col gap-2">
              {salesLinks.map((item) => (
                <Link key={item.to} to={item.to} className="text-gray-300 hover:text-white transition-colors text-sm cursor-pointer break-words">
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Контакты */}
          <div className="min-w-0">
            <h4 className="text-base font-semibold mb-4 text-white">Контакты</h4>
            <div className="space-y-3 text-gray-300 text-sm">
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-teal-400"></i>
                <span>Минск, Беларусь</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-teal-400"></i>
                <span>+375(25)5024478</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-telegram-line mt-0.5 text-teal-400"></i>
                <a href="https://t.me/a_sivko" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Telegram @a_sivko</a>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-teal-400"></i>
                <a href="mailto:info@business-training.by" className="hover:text-white transition-colors">info@business-training.by</a>
              </div>
              <div className="pt-2">
                <a href="https://sivko.by/load/privacy-policy.pdf" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-xs cursor-pointer break-words">Политика конфиденциальности</a>
              </div>
            </div>
          </div>
        </div>

        {/* Развитие персонала */}
        <div className="border-t border-gray-700 mt-10 pt-8">
          <Link to="/razvitie-personala" className="inline-block text-base font-semibold mb-4 text-white hover:text-teal-300 transition-colors cursor-pointer">Развитие персонала</Link>
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {personnelLinks.map((item) => (
              <Link key={item.to} to={item.to} className="text-gray-300 hover:text-white transition-colors text-sm cursor-pointer break-words">
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 pt-8 mt-10">
          <p className="text-gray-400 text-sm text-center">
            &copy; {new Date().getFullYear()} ИП Сивко Алексей, УНП 193531499, действующий на основании Свидетельства о государственной регистрации, №7287 в реестре рекламораспространителей.
          </p>
        </div>
      </div>
    </footer>
  );
}